import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationModalService } from "@app/admin/confirmation-modal.service";
import { CreatePrepaidAccountPopupComponent } from "../create-prepaid-account-popup/create-prepaid-account-popup.component";
import {
  RequestState,
  RequestStateEnum,
} from "@app-module/shared/RequestState";
import { PopupLayoutComponent } from "@app/admin/confirmation-popup/popup-layout/popup-layout.component";
import { Subscription } from "rxjs";
import { UserService } from "@app-service/user.service";
import { DashboardCardsService } from "@app-service/dashboard-cards.service";
import { ToasterService, ToasterType } from "@app-service/toaster.service";
import { GenericContactDetailsComponent } from "../generic-contact-details/generic-contact-details.component";
import { TRANSCORP_TENANT_VALUE, tenantSetter } from "@app-common/http/interceptors/tenantType";
@Component({
    selector: "app-meal-card-popup",
    templateUrl: "./meal-card-popup.component.html",
    styleUrls: ["./meal-card-popup.component.scss"],
    standalone: false
})
export class MealCardPopupComponent implements OnInit {
  constructor(
    public userService: UserService,
    private cardsDashboardService: DashboardCardsService,
    private toasterService: ToasterService,
    private confirmationModal: ConfirmationModalService
  ) {
    this.submitRequestState = RequestState.init();
  }

  formActionRequestState(): RequestStateEnum {
    return this.submitRequestState.state;
  }
  private subscriptions: Subscription = new Subscription();
  submitRequestState: RequestState;
  @ViewChild("modal") modal: PopupLayoutComponent;

  ngOnInit(): void {}

  onSetup(): void {
    this.confirmationModal.showInformationalModal(
      CreatePrepaidAccountPopupComponent,
      {
        centered: true,
        scrollable: true,
        size: "xl",
      }
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  onRequestDemo(): void {
    tenantSetter(TRANSCORP_TENANT_VALUE);
    this.submitRequestState.pending();
    this.subscriptions.add(
      this.cardsDashboardService
        .captureInterest("MEAL_CARD_DEMO_REQUEST")
        .subscribe(
          (res) => {
            this.modal.close();
            this.submitRequestState.completed();
            this.confirmationModal.showInformationalModal(
              GenericContactDetailsComponent,
              {
                centered: true,
                scrollable: true,
                size: "sm",
              }
            );
          },
          (err) => {
            this.submitRequestState.rejected();
            this.toasterService.showToaster(
              err["error"]["payload"]
                ? err["error"]["payload"]
                : "Something went wrong",
              ToasterType.ERROR
            );
          }
        )
    );
  }
}
